import {
  Avatar,
  BodyText,
  Eyebrow,
  Icon,
  Stack,
} from '@servicetitan/design-system';
import MessageBubble from '../MessageBubble';
import datetime from '@lib/utils/datetime';
import styles from './Message.module.css';
import { tokens } from '@servicetitan/tokens/core';
import strings from './strings';

interface MessageProps {
  message: string;
  isCustomer: boolean;
  timestamp: string;
  senderName?: string;
  isSent?: boolean;
  hasError?: boolean;
  onRetry?: () => void;
}

const Message = ({
  message,
  timestamp,
  isCustomer,
  senderName,
  isSent,
  hasError,
  onRetry,
}: MessageProps) => {
  const formattedTimestamp = datetime(timestamp).format('h:mmA');
  const customerName = senderName || 'Customer';
  const customerFirstName = customerName.split(' ')[0];

  return (
    <div>
      <Stack
        className={styles.messageStack}
        spacing={2}
        alignItems='flex-end'
        justifyContent={isCustomer ? 'flex-start' : 'flex-end'}
      >
        {isCustomer && (
          <Avatar
            className={`${styles.avatarBottom} fs-2`}
            name={customerName}
            size='l'
          />
        )}
        <Stack
          spacing={1}
          direction='column'
          alignItems={isCustomer ? 'flex-start' : 'flex-end'}
        >
          <MessageBubble isCustomer={isCustomer} error={hasError}>
            <BodyText>{message}</BodyText>
          </MessageBubble>
          {hasError ? (
            <Stack spacing={0} className={styles.error} onClick={onRetry}>
              <Stack spacing={1}>
                <Eyebrow className='c-red-500'>
                  {strings.labels.messageDeliveryError}
                </Eyebrow>
                <Eyebrow className='c-red-500'>{strings.labels.retry}</Eyebrow>
              </Stack>
              <Icon name='refresh' size={16} color={tokens.colorRed500} />
            </Stack>
          ) : (
            <Stack
              className={styles.spacingHalf}
              alignItems='center'
              justifyContent='center'
            >
              {isCustomer && (
                <>
                  <Eyebrow>{customerFirstName}</Eyebrow>
                  <Eyebrow>•</Eyebrow>
                </>
              )}
              <Eyebrow>{formattedTimestamp}</Eyebrow>
              {isSent && (
                <Icon name='check' size={17} color={tokens.colorGreen500} />
              )}
            </Stack>
          )}
        </Stack>
      </Stack>
    </div>
  );
};

export default Message;
